.modalContent {
  display: block;
  max-width: none;
  padding: 24px;
  border-radius: 20px;

  .btnClose {
    position: absolute;
    top: 1vh;
    right: 1vh;
    color: var(--white);
    cursor: pointer;
    border-radius: 46px;
    padding: 4px 6px;
    background: #cbb;
    line-height: 6px;
  }

  .header {
    display: flex;
    align-items: center;

    .img {
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      height: 200px;
      font-weight: bolder;
      border-radius: 20px;
      background: #dcdcdc;
    }

    .btnSelect {
      margin: auto;
    }
  }

  .charityName {
    margin-top: 24px;
    color: var(--yellow);
    font-size: 28px;
    font-weight: bold;
  }

  .link {
    font-size: 20px;

    i {
      margin-right: 8px;
    }
  }

  .detailItem {
    margin-top: 8px;
    font-size: 16px;
    color: var(--gray);
  }

  .description {
    margin-top: 16px;
    font-size: 18px;
    color: var(--gray);
  }
}
